/* Calunar FAQ-Akkordeon. Gilt fuer jedes Element mit data-cal-faq, auf der
   Produktseite eine Liste, auf der Kontaktseite alle Themen zusammen.

   Ohne JS bleibt das Verhalten ueber das name-Attribut der details erhalten
   (nur eine Frage offen, ohne Animation). Mit JS uebernehmen wir das Oeffnen
   selbst, damit die alte Antwort weich zuklappt statt zu springen. Deshalb
   wird das name-Attribut entfernt, sonst schliesst der Browser die vorherige
   Frage sofort und die Animation liefe ins Leere. */
(function () {
  'use strict';

  var OPEN_MS = 360;
  var CLOSE_MS = 260;
  var EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function panelOf(item) { return item.querySelector('.cal-faq__a'); }

  function slide(item, opening, onDone) {
    var panel = panelOf(item);
    if (!panel) { if (onDone) onDone(); return; }

    if (panel.calAnim) panel.calAnim.cancel();

    var height = panel.scrollHeight;
    panel.style.overflow = 'hidden';

    var anim = panel.animate(
      [
        { height: (opening ? 0 : height) + 'px', opacity: opening ? 0 : 1 },
        { height: (opening ? height : 0) + 'px', opacity: opening ? 1 : 0 }
      ],
      { duration: opening ? OPEN_MS : CLOSE_MS, easing: EASE }
    );

    panel.calAnim = anim;
    anim.onfinish = anim.oncancel = function () {
      panel.calAnim = null;
      panel.style.overflow = '';
      if (onDone) onDone();
    };
  }

  function close(item, animate) {
    if (!item.open) return;
    if (!animate) { item.open = false; return; }
    item.classList.add('is-closing');
    slide(item, false, function () {
      item.classList.remove('is-closing');
      item.open = false;
    });
  }

  function open(item, animate) {
    item.open = true;
    if (animate) slide(item, true);
  }

  /* Klappt oberhalb eine lange Antwort zu, wandert die angetippte Frage sonst
     um deren Hoehe nach oben aus dem Blick. Wir halten sie waehrend der
     Animation an ihrer Stelle. scrollTo statt scrollBy mit Optionsobjekt:
     laeuft ueberall sofort, scroll-behavior steht im Theme auf auto. */
  function holdInPlace(anchor, start, ms) {
    var until = performance.now() + ms;

    (function step(now) {
      var delta = anchor.getBoundingClientRect().top - start;
      if (Math.abs(delta) > 0.5) window.scrollTo(window.pageXOffset, window.pageYOffset + delta);
      if (now < until) requestAnimationFrame(step);
    })(performance.now());
  }

  function init(root) {
    if (root.calFaqReady) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('details'));
    if (!items.length || !items[0].animate) return;

    root.calFaqReady = true;
    items.forEach(function (item) { item.removeAttribute('name'); });

    root.addEventListener('click', function (event) {
      var summary = event.target.closest ? event.target.closest('summary') : null;
      if (!summary || !root.contains(summary)) return;

      var item = summary.parentElement;
      if (items.indexOf(item) === -1) return;

      event.preventDefault();
      var animate = !reduced();

      if (item.open) {
        close(item, animate);
        return;
      }

      var above = items.some(function (other) {
        return other !== item && other.open && other.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING;
      });

      /* Ausgangsposition messen, bevor sich etwas bewegt. */
      var anchorTop = above ? summary.getBoundingClientRect().top : 0;

      items.forEach(function (other) {
        if (other !== item) close(other, animate);
      });
      open(item, animate);

      if (above) holdInPlace(summary, anchorTop, animate ? CLOSE_MS + 60 : 0);
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cal-faq]'), init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
